import React, { useState, useEffect } from 'react';
import { get, isArray, isEmpty, isNull } from 'lodash';
// Components
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import NoData from '../../../../../components/NoData';
import './styles.scss';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';

export default function TestPerformanceRecordTab(props) {
  // State
  const [datesData, isDatesData] = useState([]);
  const [headerFilters, setHeaderFilters] = useState([]);
  const [subHeaderFilters, setSubHeaderFilters] = useState([]);
  const [header, setHeader] = useState('');
  const [visibleHeader, setVisibleHeader] = React.useState(false);
  const [subHeader, setSubHeader] = useState('');
  const [visibleSubHeader, setVisibleSubHeader] = React.useState(false);
  const [tableHeader, setTableHeader] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);

  const handleClickHeader = (event) => {
    setAnchorEl(event.currentTarget);
    showDialog('header');
  };
  const handleClickSubHeader = (event) => {
    setAnchorE2(event.currentTarget);
    showDialog('subheader');
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClose2 = () => {
    setAnchorE2(null);
  };
  useEffect(() => {
    organiseData();
  }, []);

  useEffect(() => {
    if (header && subHeader) {
      let headerIndex = headerFilters.indexOf(header),
        subHeaderIndex = subHeaderFilters.indexOf(subHeader);
      let start = 1,
        end = 0,
        obj = {};
      setTableHeader(
        props.data.main_header[headerIndex].header[subHeaderIndex].sub_header
      );

      // Looping to find the position of data in the array
      for (let j = 1; headerFilters.length > j; j++) {
        for (let i = 0; subHeaderFilters.length > i; i++) {
          obj[props.data.main_header[j].header[i].value] = `${start} - ${
            start + props.data.main_header[j].header[i].sub_header.length
          }`;
          end = start + props.data.main_header[j].header[i].sub_header.length;
          if (
            header == props.data.main_header[j].header_title &&
            subHeader == props.data.main_header[j].header[i].value
          ) {
            break;
          }
          start = end;
        }
        if (header == props.data.main_header[j].header_title) {
          break;
        }
      }

      // Table data content
      let tableDataContent = [];
      if (isArray(props.data.detail[0])) {
        get(props, 'data.detail', []).map((x) => {
          tableDataContent.push([x.slice(start, end)]);
        });
      } else {
        tableDataContent.push([props.data.detail.slice(start, end)]);
      }

      setTableData(tableDataContent);
    }
  }, [header, subHeader]);

  const organiseData = () => {
    let filter1 = [];
    get(props, 'data.main_header', []).map((x) => {
      filter1.push(x.header_title);
    });
    if (!isEmpty(props.data.detail)) {
      if (isArray(props.data.detail[0])) {
        let dateArr = [];
        get(props, 'data.detail', []).map((x) => {
          dateArr.push(x[0]);
        });
        isDatesData(dateArr);
      } else {
        isDatesData(props.data.detail[0]);
      }
    }
    setHeaderFilters(filter1);
  };

  const selectedLevel1Filter = (filter) => {
    let filterIndex = headerFilters.indexOf(filter);
    let filters = [];
    get(props.data.main_header[filterIndex], 'header', []).map((x) => {
      filters.push(x.value);
    });
    setHeader(filter);
    setSubHeaderFilters(filters);
  };

  const selectedLevel2Filter = (filter) => {
    setSubHeader(filter);
  };

  const populateTable = () => {
    let headerContent = [];
    let dataContent = [];
    headerContent.push(<TableCell>Date</TableCell>);
    tableHeader.map((data) => {
      headerContent.push(<TableCell align="right">{data}</TableCell>);
    });

    tableData.map((data, index) => {
      let dataRows = [];
      dataRows.push(<TableCell>{datesData[index]}</TableCell>);
      data.map((x) => {
        x.map((y) => {
          dataRows.push(<TableCell align="right"> {y}</TableCell>);
        });
      });
      dataContent.push(<TableRow>{dataRows}</TableRow>);
    });
    return (
      <TableContainer className="table-container scroll-table">
        <PerfectScrollbar>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>{headerContent}</TableRow>
            </TableHead>
            <TableBody>{dataContent}</TableBody>
          </Table>
        </PerfectScrollbar>
      </TableContainer>
    );
  };

  const populateFullTable = () => {
    let mainHeader = [],
      header = [],
      subHeader = [],
      details = [];
    props.data.main_header.map((x) => {
      let colspan = (get(x, 'header', []) || []).length;
      (get(x, 'header', []) || []).map((headerContent) => {
        colspan = colspan + (get(headerContent, 'sub_header', []) || []).length;
        header.push(
          <TableCell
            colSpan={(get(headerContent, 'sub_header', []) || []).length}
            align="center"
            style={{ top: 35 }}
          >
            {get(headerContent, 'value', '')}
          </TableCell>
        );
        (get(headerContent, 'sub_header', ['']) || [1]).map(
          (subHeaderContent) => {
            subHeader.push(
              <TableCell align="center" style={{ top: 70 }}>
                {subHeaderContent}
              </TableCell>
            );
          }
        );
      });
      mainHeader.push(
        <TableCell
          align="center"
          colSpan={colspan}
          rowSpan={isNull(get(x, 'header')) ? 3 : 1}
        >
          {x.header_title}
        </TableCell>
      );
    });

    props.data.detail.map((y) => {
      let eachRow = [];
      y.map((row) => {
        eachRow.push(<TableCell align="center">{row}</TableCell>);
      });
      details.push(<TableRow align="center">{eachRow}</TableRow>);
    });

    return (
      <TableContainer className="table-container scroll-table">
        <Table stickyHeader aria-label="sticky table" size="small">
          <TableHead>
            <TableRow>{mainHeader}</TableRow>
            <TableRow>{header}</TableRow>
            <TableRow>{subHeader}</TableRow>
          </TableHead>
          <TableBody>{details}</TableBody>
        </Table>
      </TableContainer>
    );
  };

  const populateHeaderFilters = () => {
    let filters = [
      <MenuItem
        key={`Menuitem`}
        onClick={() => {
          selectedLevel1Filter('');
          selectedLevel2Filter('');
          hideDialog('header');
          handleClose();
        }}
      >
        <span>All</span>
      </MenuItem>,
    ];
    headerFilters.map((data, index) => {
      if (index === 0) return;
      filters.push(
        <MenuItem
          key={index}
          onClick={() => {
            selectedLevel1Filter(data);
            hideDialog('header');
            handleClose();
          }}
        >
          <span>{data}</span>
        </MenuItem>
      );
    });

    return <div>{filters}</div>;
  };

  const populateSubHeaderFilters = () => {
    let filters = [];
    subHeaderFilters.map((data) => {
      filters.push(
        <MenuItem
          onClick={() => {
            selectedLevel2Filter(data);
            hideDialog('subheader');
            handleClose2();
          }}
        >
          <span>{data}</span>
        </MenuItem>
      );
    });

    return <div>{filters}</div>;
  };

  const showDialog = (type) => {
    switch (type) {
      case 'header':
        setVisibleHeader(true);
        break;
      default:
        setVisibleSubHeader(true);
    }
  };

  const hideDialog = (type) => {
    switch (type) {
      case 'header':
        setVisibleHeader(false);
        break;
      default:
        setVisibleSubHeader(false);
    }
  };

  return (
    <div className="card content-card overall-data">
      {isEmpty(props.data.main_header) || isEmpty(props.data.detail) ? (
        <div className="position-relative">
          <NoData message={'As of now, No Performance Records are available'} />
        </div>
      ) : (
        <div>
          <div>
            <div className="filter-sec">
              <div className="paper-box">
                <Button
                  variant="outlined"
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClickHeader}
                >
                  {header ? `Paper : ${header}` : 'Please Select Paper'}
                  <span className="caret ml-10" />
                </Button>
              </div>

              {header && (
                <div className="paper-box">
                  <Button
                    variant="outlined"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={handleClickSubHeader}
                  >
                    {subHeader
                      ? `Subject : ${subHeader}`
                      : 'Please Select Subject'}
                    <span className="caret ml-10" />
                  </Button>
                </div>
              )}
            </div>
            <>{header && subHeader ? populateTable() : populateFullTable()}</>
          </div>
          {visibleHeader && (
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {populateHeaderFilters()}
            </Menu>
          )}
          {visibleSubHeader && (
            <Menu
              id="simple-menu"
              anchorEl={anchorE2}
              keepMounted
              open={Boolean(anchorE2)}
              onClose={handleClose2}
            >
              {populateSubHeaderFilters()}
            </Menu>
          )}{' '}
        </div>
      )}
    </div>
  );
}
TestPerformanceRecordTab.propTypes = {
  data: PropTypes.object,
};
